// delete with removal of contentTypeMenuUpdate FF
import { connect } from 'react-redux';
import { defaultMemoize } from 'reselect';
import * as _ from 'underscore';

import { GenericMenuItemInfo } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { getMixedContentInOrder } from '../../../contentDefinitionInterfaces/ContentDefinitionsLists';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { selectContentCounts } from '../../selectors/ContentCountsSelector';
import { AppState } from '../../state/AppState';
import { ISpaceInfoTypeItemCount, SpaceInfoTypeContentCounts } from '../../state/ContentCountsState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { ConnectedFilterByTypeMenuHelpers } from '../Components/ConnectedFilterByTypeMenuHelpers';
import { ExplorerDropdownItemHeaderFormatter, ExplorerDropdownItemNoCountFormatter, ExplorerDropdownSeparatorFormatter } from '../Components/ExplorerDropdownPanelItems';
import { ExplorerListMenuPanel, ExplorerListMenuPanelOwnProps, ExplorerListMenuPanelStateProps } from '../Components/ExplorerListMenuPanel';
import { MixedContentItemDefinition } from '../../../contentDefinitionInterfaces/ContentDefinitionsTypes';

export const ShowWorkbookAsViewsValue = 'showWorkbooksAsViews';

export const getContentDefinitionsForUserSpaceMenu = (
  showWorkbooksAsViews: boolean,
  flowsEnabled: boolean
): MixedContentItemDefinition[] => {
  const items: MixedContentItemDefinition[] = [];

  const mixedContentInOrder = getMixedContentInOrder();

  for (const typeDef of mixedContentInOrder) {
    if (
      (flowsEnabled || typeDef.itemType !== 'flow') &&
      (typeDef.itemType !== 'metric'|| FeatureFlags.metricsSpaceEnabled) &&
      (typeDef.itemType !== 'publishedConnection'|| FeatureFlags.publishedConnectionContentManagementEnabled)) {
      if (!showWorkbooksAsViews && typeDef.itemType === 'view') {
        // Showing workbooks only.
        continue;
      } else if (showWorkbooksAsViews && typeDef.itemType === 'workbook') {
        // Showing views instead.
        continue;
      }
      items.push(typeDef);
    }
  }

  return items;
};

const getUserSpaceMenuItems = (
  currentTypeFilters: ReadonlyArray<ExploreContentApi_ContentType>,
  contentCounts: ISpaceInfoTypeItemCount<'siteuser'>,
  contentCountsUpToDate: boolean,
  showWorkbooksAsViews: boolean,
  flowsEnabled: boolean
): GenericMenuItemInfo[] => {
  let menuItems: GenericMenuItemInfo[] = ConnectedFilterByTypeMenuHelpers.mapToMenuItems(
    getContentDefinitionsForUserSpaceMenu(showWorkbooksAsViews, flowsEnabled),
    currentTypeFilters,
    contentCounts,
    contentCountsUpToDate
  );

  menuItems.push({
    value: 'optionsSectionSeparator',
    disabled: true,
    checked: false,
    displayFormatterBoundWithData: ExplorerDropdownSeparatorFormatter()
  });

  menuItems.push({
    value: 'optionsSectionHeader',
    disabled: true,
    checked: false,
    displayFormatterBoundWithData: ExplorerDropdownItemHeaderFormatter(Messages.filterByTypeDropdown_options())
  });

  menuItems.push({
    value: ShowWorkbookAsViewsValue,
    disabled: !showingViewsOrWorkbooks(currentTypeFilters),
    checked: showWorkbooksAsViews,
    displayFormatterBoundWithData: ExplorerDropdownItemNoCountFormatter(Messages.filterByTypeDropdown_showWorkbooksAsViews()),
    keyboardAccessibleValue: Messages.filterByTypeDropdown_showWorkbooksAsViews()
  });

  return menuItems;
};

const showingViewsOrWorkbooks = (currentTypeFilters: ReadonlyArray<ExploreContentApi_ContentType>): boolean => {
  return _.some(currentTypeFilters, (contentType: ExploreContentApi_ContentType) => {
    return contentType === 'workbook'
      || contentType === 'view';
  });
};

const getUserSpaceMenuItemsWrapper = defaultMemoize(getUserSpaceMenuItems);

export const mapStateToUserSpaceProps: MapStateToProps<ExplorerListMenuPanelStateProps> =
  (state: AppState) => {
    const contentCounts = selectContentCounts<'siteuser'>(state, 'siteuser');
    return ConnectedFilterByTypeMenuHelpers.mapStateToProps(state, contentCounts as SpaceInfoTypeContentCounts, getUserSpaceMenuItemsWrapper);
  };

export const ConnectedUserSpaceFilterByTypeMenu: React.ComponentClass<ExplorerListMenuPanelOwnProps> =
  connect(mapStateToUserSpaceProps, ConnectedFilterByTypeMenuHelpers.mapDispatchToProps)(ExplorerListMenuPanel);
